import 'react';

const DialogCollapseSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                stroke="#878D99"
                strokeWidth={1.25}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.5 8.5L10 13l4.5-4.5"
            />
        </g>
    </svg>
);

export default DialogCollapseSvg;
